import ExampleItem from "../example-item";
import Text from "../text/text";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useNavigationStore } from "../../store/navigationStore";
import useMdBreakpoint from "../../hooks/useMdBreakpoint";
import { useAppStore } from "../../store/appStore";
import { useLanguageStore } from "./../../store/languageStore";
import { CHAT_TYPE } from "../../types/navigation-mode";
import HomeChat from "./home-chat";
import HomeException from "./home-exception";
import useMessagePlayer from "@/hooks/useMessagePlayer";
import { filterAvailableVoiceNames } from "@/utils/speech";
import { useSearchParams } from "react-router-dom";
import LoadingMask from "../lottie/loading-mask";
import AugmentedRealityDemoButton from "@/components/augmentedRealityViewer/augmentedRealityDemoButton";

export default function Home() {
  const userId = useAppStore((state) => state.userId);
  const setUserId = useAppStore((state) => state.setUserId);
  const hasUserInteraction = useAppStore((state) => state.hasUserInteraction);
  const setHasUserInteraction = useAppStore(
    (state) => state.setHasUserInteraction,
  );
  const voiceLanguage = useLanguageStore((state) => state.voiceLanguage);
  const setVoiceOn = useLanguageStore((state) => state.setVoiceOn);

  const venueNotSupported = useNavigationStore(
    (state) => state.venueNotSupported,
  );
  const apiError = useNavigationStore((state) => state.apiError);
  const hasChatHistory = useNavigationStore(
    (state) => state.chatHistory.length > 0,
  );
  const isMd = useMdBreakpoint();
  const { readText } = useMessagePlayer();

  const voiceNames = useLanguageStore((s) => s.voiceNames);
  const setVoiceNames = useLanguageStore((s) => s.setVoiceNames);
  const voiceLang = useLanguageStore((s) => s.voiceLanguage);
  const chatType = useAppStore((s) => s.chatType);

  const [searchParams] = useSearchParams();
  const startVenueId = searchParams.get("v");
  const startMapId = searchParams.get("m");
  const startCoordinate = searchParams.get("p");
  const startPoi = searchParams.get("n");

  const [homeChatType, setHomeChatType] = useState(chatType);
  const setStartPosition = useNavigationStore(
    (state) => state.setStartPosition,
  );

  useEffect(() => {
    setHomeChatType(chatType);
  }, [chatType]);

  useEffect(() => {
    if (!userId) {
      setUserId(uuidv4());
    }
  }, [userId]);

  function isSpeechNotSupported() {
    const speechNotSupported = !("speechSynthesis" in window);
    return speechNotSupported;
  }

  useEffect(() => {
    if (voiceNames.length == 0) {
      if (!isSpeechNotSupported()) {
        const availableVoices = filterAvailableVoiceNames(
          voiceLang,
          (loadedVoices) => {
            setVoiceNames(loadedVoices);
          },
        );

        if (availableVoices && availableVoices.length > 0) {
          setVoiceNames(availableVoices);
        }
      }
    }
    console.log(
      "search params: ",
      startVenueId,
      startMapId,
      startCoordinate,
      startPoi,
    );
    if (startVenueId && startMapId && startCoordinate && startPoi) {
      setStartPosition(startVenueId, startMapId, startCoordinate, startPoi);
    }
  }, []);

  // useEffect(() => {
  //   function handleFirstInteraction() {
  //     readText("", voiceLanguage, false);
  //     setVoiceOn(true);
  //     window.removeEventListener("click", handleFirstInteraction);
  //     window.removeEventListener("touchstart", handleFirstInteraction);
  //   }
  //   window.addEventListener("click", handleFirstInteraction);
  //   window.addEventListener("touchstart", handleFirstInteraction);
  //   return () => {
  //     window.removeEventListener("click", handleFirstInteraction);
  //     window.removeEventListener("touchstart", handleFirstInteraction);
  //   };
  // }, []);

  function checkUserInteraction() {
    console.log("hasUserInteraction, ", hasUserInteraction);
    // trigger a silent speech synthesis on the first user interaction.
    // to allow speech synthesis to work on mobile
    if (!hasUserInteraction) {
      readText("", voiceLanguage, true);
      setHasUserInteraction(true);
    }
  }

  const HomeLanding = () => {
    return (
      <>
        <div className="flex flex-col mb-[40px]">
          <Text
            text="landing"
            className="text-center pb-[20px] font-medium text-lg leading-7 tracking-normal align-middle"
          />
        </div>
        {
          <div
            className={`flex flex-col gap-[8px] mb-[40px]${
              venueNotSupported ? "hidden md:flex" : ""
            }`}
          >
            <Text text="example" />
            <ExampleItem
              type={CHAT_TYPE.SIMULATION}
              question="example_simulation"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleHKIA1"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleHKIA2"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleHKIA3"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleAS"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleWKS"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleWKS2"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleWKS3"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleEntranceToTea"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleEntranceToStudio1"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleAtriumToStarPlace"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="exampleTicketToGrandTheatre"
              onClick={() => checkUserInteraction()}
            />
            {process.env.REACT_APP_ENV === "development" ? (
              <ExampleItem
                type={CHAT_TYPE.NAVIGATION}
                question="Navigation Custom Json"
                onClick={() => checkUserInteraction()}
              />
            ) : (
              <></>
            )}

            <AugmentedRealityDemoButton />
            {/*
                        <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="example0"
              onClick={() => checkUserInteraction()}
            />
              <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="example1"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="example2"
              onClick={() => checkUserInteraction()}
            />
            <ExampleItem
              type={CHAT_TYPE.NAVIGATION}
              question="example3"
              onClick={() => checkUserInteraction()}
            />
            */}
          </div>
        }
      </>
    );
  };

  return (
    <>
      <div className="flex flex-1 md:flex-row">
        <div className="flex flex-col items-center justify-items-center p-8 flex-1">
          <div className="w-full h-full md:max-w-[520px]">
            {venueNotSupported || apiError != "" || hasChatHistory ? (
              <HomeException />
            ) : (
              HomeLanding()
            )}
          </div>
        </div>
      </div>
      <HomeChat onSend={() => checkUserInteraction()} chatType={homeChatType} />
      <LoadingMask />
    </>
  );
}
